import { useState } from 'react';

import { api } from '../api';

/** Resolve a recorded exception. The note is required and kept with the exception. */
export function ResolveExceptionForm({
  exceptionId,
  onResolved,
}: {
  exceptionId: string;
  onResolved: () => void;
}) {
  const [note, setNote] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const noteId = `resolution-note-${exceptionId}`;

  const submit = async () => {
    setSaving(true);
    setError(null);
    try {
      await api.resolveException(exceptionId, note.trim());
      onResolved();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Could not resolve the exception.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="space-y-2">
      <label
        htmlFor={noteId}
        className="block text-xs font-medium uppercase tracking-wide text-ink-faint"
      >
        Resolution note
      </label>
      <textarea
        id={noteId}
        value={note}
        onChange={(e) => setNote(e.target.value)}
        rows={3}
        maxLength={2000}
        placeholder="What was done, for example: hours allocated by hand to the week ending 12/24."
        className="w-full rounded-lg border border-edge bg-surface-base px-3 py-2 text-sm"
      />
      {error !== null && <p className="text-xs text-caution">{error}</p>}
      <button
        type="button"
        onClick={() => void submit()}
        disabled={saving || note.trim() === ''}
        className="rounded-lg border border-profit bg-profit/10 px-4 py-2 text-sm font-medium text-profit transition-colors hover:bg-profit/20 disabled:opacity-50"
      >
        {saving ? 'Resolving…' : 'Resolve'}
      </button>
    </div>
  );
}
